<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { usePrimeVue } from 'primevue/config';
import { useLayout } from '@/layout/composables/layout';
import AppTopbarMenu from './AppTopbarMenu.vue';
import CompanySelector from './CompanySelector.vue';
import { useStates } from '../router/states';

const $primevue = usePrimeVue();
const { userState } = useStates();

defineExpose({
  $primevue,
});

const { onMenuToggle, onTopbarMenuToggle, layoutState } = useLayout();

const onMenuButtonClick = () => {
  onMenuToggle();
};
const onMobileTopbarMenuButtonClick = () => {
  onTopbarMenuToggle();
};

// Reactive window width
const windowWidth = ref(window.innerWidth);

const updateWidth = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener('resize', updateWidth);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateWidth);
});

// Computed para determinar el ícono según el estado del sidebar
const menuIcon = computed(() => {
  const isDesktop = windowWidth.value > 991;

  if (isDesktop) {
    // Desktop: true = cerrado → chevron-right, false = abierto → chevron-left
    return layoutState.staticMenuDesktopInactive.value ? 'pi-chevron-right' : 'pi-chevron-left';
  } else {
    // Móvil: true = abierto → chevron-left, false = cerrado → chevron-right
    return layoutState.staticMenuMobileActive.value ? 'pi-chevron-left' : 'pi-chevron-right';
  }
});
</script>

<template>
  <div class="layout-topbar">
    <div class="layout-topbar-start flex align-items-center justify-content-start">
      <!-- Reemplazamos el router-link por nuestro CompanySelector integrado -->
      <CompanySelector v-if="userState?.data?.value?.email"></CompanySelector>

      <a v-ripple ref="menuButton" class="p-ripple layout-menu-button mobile-menu-button" @click="onMenuButtonClick()">
        <i :class="['pi', menuIcon]"></i>
      </a>

      <a
        v-ripple
        ref="mobileMenuButton"
        class="p-ripple layout-topbar-mobile-button"
        @click="onMobileTopbarMenuButtonClick()">
        <i class="pi pi-ellipsis-v"></i>
      </a>
    </div>

    <div class="layout-topbar-end d-flex align-items-center justify-content-end">
      <AppTopbarMenu></AppTopbarMenu>
    </div>
  </div>
</template>

<style>
.layout-topbar-logo-full,
.layout-topbar-logo-slim {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

/* Estilo para el botón de menú en pantallas pequeñas */
@media screen and (max-width: 991px) {
  .mobile-menu-button {
    position: absolute !important;
    right: 20px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    z-index: 1000 !important;
  }

  /* Asegurar que el CompanySelector deje espacio para el botón */
  .company-selector-container {
    max-width: calc(100% - 70px) !important; /* Dejar espacio para el botón + margen */
  }
}
</style>
